{
  "version": 2,
  "name": "Vendovi Island",
  "displayInfo": {
    "description": "A single small island in Washington's Rosario Strait. A compact playground for short trips and close-quarters handling.",
    "difficulty": "beginner"
  },
  "region": {
    "datasetPath": "wash_bellingham/",
    "bbox": {
      "minLat": 48.603606,
      "minLon": -122.617323,
      "maxLat": 48.617294,
      "maxLon": -122.595673
    },
    "interval": 25,
    "simplify": 5,
    "scale": 1,
    "minPerimeter": 1500,
    "minPoints": 4,
    "flipY": true
  },
  "waves": {
    "sources": [
      {
        "amplitude": 0.32,
        "wavelength": 32,
        "direction": 0.79,
        "phaseOffset": 0.0
      },
      {
        "amplitude": 0.14,
        "wavelength": 12,
        "direction": 0.85,
        "phaseOffset": 1.62
      },
      {
        "amplitude": 0.18,
        "wavelength": 22,
        "direction": 0.0,
        "phaseOffset": 3.24
      },
      {
        "amplitude": 0.06,
        "wavelength": 5,
        "direction": 0.75,
        "phaseOffset": 4.85
      }
    ]
  },
  "wind": {
    "sources": [
      {
        "direction": 0.6
      }
    ]
  },
  "startPosition": [-500, 2000],
  "biome": {
    "zones": [
      {
        "maxHeight": 8,
        "color": [0.55, 0.52, 0.45],
        "colorAlt": [0.48, 0.45, 0.4],
        "noiseBlend": 0.3,
        "treeDensity": 0
      },
      {
        "maxHeight": 25,
        "color": [0.22, 0.3, 0.14],
        "colorAlt": [0.18, 0.22, 0.1],
        "noiseBlend": 0.5,
        "treeDensity": 0.6
      },
      {
        "maxHeight": 120,
        "color": [0.1, 0.2, 0.07],
        "colorAlt": [0.14, 0.16, 0.06],
        "noiseBlend": 0.5,
        "treeDensity": 0.85
      },
      {
        "maxHeight": 300,
        "color": [0.08, 0.16, 0.05],
        "colorAlt": [0.12, 0.12, 0.05],
        "noiseBlend": 0.4,
        "treeDensity": 0.8
      },
      {
        "maxHeight": 600,
        "color": [0.38, 0.42, 0.36],
        "colorAlt": [0.42, 0.4, 0.35],
        "noiseBlend": 0.3,
        "treeDensity": 0.3
      },
      {
        "maxHeight": 9999,
        "color": [0.52, 0.52, 0.5],
        "colorAlt": [0.48, 0.48, 0.45],
        "noiseBlend": 0.2,
        "treeDensity": 0
      }
    ],
    "rockColor": [0.42, 0.42, 0.4],
    "rockThreshold": 0.55,
    "snowlineHeight": -1,
    "largeNoiseScale": 0.004,
    "smallNoiseScale": 0.25
  },
  "trees": {
    "spacing": 15,
    "density": 1.0,
    "minElevation": 8,
    "maxElevation": 300
  }
}
